export class Department 
{
    public DepartmentId : number;
    public DepartmentCode : string;
    public DepartmentName : string;
    public CompId : number;
    public BranchId : number;
    public IsActive : boolean;
    public FunctionalHead : number;
}